module.exports = __webpack_public_path__ + "img/3.55c169c2.webp";